<div [hidden]="!this.data || this.queryError">
    <app-dynamic-mat-table
        [data]="this.data"
        [entity]="'sets'"></app-dynamic-mat-table>
</div>

<div *ngIf="this.queryError">
    <app-query-error></app-query-error>
</div>
